import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import VehicleList from 'modules/vehicle-section/VehicleList';
import VehicleDetail from 'modules/vehicle-section/VehicleDetail';

import { Route } from 'react-router-dom';

const VehicleSection = ({ match }) => {
  return (
    <Fragment>
      <Route path={match.url} component={VehicleList} />
      <Route path={`${match.url}/:id`} component={VehicleDetail} />
    </Fragment>
  );
};

VehicleSection.propTypes = {
  vehicles: PropTypes.array,
  url: PropTypes.string,
  query: PropTypes.object,
  replace: PropTypes.func,
  updateVehicle: PropTypes.func,
  params: PropTypes.object,
  carriers: PropTypes.array,
  routes: PropTypes.array,
  fetchDedicatedContracts: PropTypes.func,
  match: PropTypes.object,
  loading: PropTypes.bool,
};

export default VehicleSection;
